import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css'
import '../assets/css/pcindex.css'
import 'animate.css'
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$layer = layer(Vue)
Vue.prototype.throttle = function (fun, delay) {
  let last, deferTimer
  return function () {
      let that = this
      let _args = arguments
      let now = +new Date()
      if (last && now < last + delay) {
          clearTimeout(deferTimer)
          deferTimer = setTimeout(function () {
              last = now
              fun.apply(that, _args)
          }, delay)
      }else {
          last = now
          fun.apply(that,_args)
      }
  }
}
/* 
 * 封装ajax
 * obj : 全局this
 * data : ajax传入后台data数据
 * address : ajax接口地址
 * fn : 成功返回方法  带参数  obj,data  obj : this data : response
 * */
var baseUrl = "https://admin.csback.gamemorefun.net"
Vue.prototype.postHttp = function (obj, data, address, fn) {
  obj.$axios.post(baseUrl + address, data).then(response => {
    fn(obj, response.data);

  }, response => {

  })
}
Vue.prototype.getHttp = function (obj, data, address, fn) {
  obj.$axios.get(baseUrl + address, { params: data }).then(function (response) {
    fn(obj, response.data)
  }).catch(function (response) {
    console.log(response);//发生错误时执行的代码
  });
}
new Vue({
  render: h => h(App),
}).$mount('#app')
